import { AppLanguage } from '~/types/locale'

import getLanguageFromCurriculumCode from '../utils/getLanguageFromCurriculumCode'
import { CurriculumCountryCodes } from '../constants/curriculum.const'

import { useGetUserChosenCurriculumCountryCode } from './useGetCurriculumCountryCode'

export default function useGetExpectedLanguage(): AppLanguage | undefined {
  const curriculumCountryCode = useGetUserChosenCurriculumCountryCode()
  if (!curriculumCountryCode) {
    return
  }
  return getLanguageFromCurriculumCode(curriculumCountryCode as CurriculumCountryCodes)
}
